import {cookies} from './cookies'

const modal = (() => {
    let activeModal = null;
    const html = document.querySelector('html');

    const init = () => {
        const popup = document.querySelector('[data-popup-modal]');
        const triggers = document.querySelectorAll('[data-modal]');
        const close = document.querySelectorAll('[data-close-modal]');
        triggers.forEach(trigger => (trigger.onclick = () => initEvent(trigger)));
        close.forEach(each => (each.onclick = closeModal));

        if (popup) setTimeout(() => initEvent(popup, true), 500);
    };

    const getElementIndex = (trigger) => {
        const hasListParent = trigger.closest('ul');

        if (!hasListParent)
            return 0;

        if (trigger.matches('li'))
            return [...hasListParent.children].indexOf(trigger)

        const parentListItem = trigger.closest('li');

        return [...hasListParent.children].indexOf(parentListItem) * 4 + [...parentListItem.children].indexOf(trigger);
    };

    const initEvent = (trigger, triggerIsModal = false) => {
        const modal = triggerIsModal ? trigger : document.querySelector(trigger.dataset.modal)

        const component = {
            trigger,
            modal,
            swiper: modal.querySelector("[data-swiper]"),
            triggerIndex: getElementIndex(trigger)
        };

        openModal(component);
    };

    const openModal = (component) => {
        activeModal = component;
        component.modal.classList.add("active");
        html.classList.add("modalOpened");

        setTimeout(function () {
            component.modal.classList.add("animated");
        }, 100);

        setTimeout(function () {
            if (component.swiper) {
                component.swiper.swiper.slideTo(component.triggerIndex);
                component.swiper.swiper.update();
            }
        }, 300);
    };

    const closeModal = () => {
        if (!activeModal) return;

        activeModal.modal.classList.remove("active", "animated");
        html.classList.remove("modalOpened");

        if(activeModal.modal.id === 'modal-newsletter')
            cookies.createCookie('newsletter', true, 30);

        activeModal = null;

    };

    return {
        init: init,
        closeModal: closeModal,
        openModal: openModal
    };
})();

export {modal}